/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */

// Zajednički stilovi i helperi za react-select, korišćeni u svim formama.

export const filterByPrefix = (option, inputValue) => {
  if (!inputValue) return true;
  return option.label.toLowerCase().startsWith(inputValue.toLowerCase());
};

export const selectStyles = { menuPortal: (base) => ({ ...base, zIndex: 9999 }) };

export const selectClassNames = {
  control: ({ isFocused }) =>
    `bg-sage-50 border rounded-2xl pl-9 pr-2 py-2 cursor-pointer transition-all ${
      isFocused ? 'ring-2 ring-sage-200 border-sage-200' : 'border-sage-100'
    }`,
  valueContainer: () => 'px-2 py-1.5',
  placeholder: () => 'text-sage-400',
  input: () => 'text-earth-900',
  singleValue: () => 'text-earth-900 font-medium',
  menu: () => 'bg-white rounded-2xl shadow-2xl border border-sage-100 overflow-hidden mt-2 z-20',
  menuList: () => 'py-2 max-h-60',
  option: ({ isFocused, isSelected }) =>
    `cursor-pointer px-5 py-2.5 text-sm transition-colors ${
      isSelected
        ? 'bg-sage-600 text-white font-bold'
        : isFocused
        ? 'bg-sage-50 text-earth-900'
        : 'bg-white text-earth-900'
    }`,
  indicatorSeparator: () => 'hidden',
  dropdownIndicator: () => 'text-sage-400 hover:text-sage-600 px-2 transition-colors',
  clearIndicator: () => 'text-sage-400 hover:text-sage-600 px-1 cursor-pointer',
  noOptionsMessage: () => 'text-sage-400 text-sm italic px-5 py-3 text-center',
};
